<template>
  <div class="">
    <StatisticsCard
      :title="title"
      :totalNumber="totalNumber"
      :icon="icon"
      :data="data"
    />
  </div>
</template>

<script>
import StatisticsCard from "@/components/general/StatisticsCard.vue";

export default {
  name: "SpecialSpecialties",
  props: ["specialSpecialties"],
  components: {
    StatisticsCard,
  },
  data() {
    return {
      title: this.$t("specialSpecialties"),
      totalNumber: 0,
      icon: "special-spcialities.svg",
      data: [
        { title: this.$t("statistics.notArchived"), value: 0 },
        { title: this.$t("statistics.archived"), value: 0 },
      ],
    };
  },
  methods: {
    fillData() {
      this.totalNumber = this.specialSpecialties.totalCountSpecialSpecialties;
      this.data[0].value =
        this.specialSpecialties.totalCountSpecialSpecialtiesNotActive;
      this.data[1].value =
        this.specialSpecialties.totalCountSpecialSpecialtiesArchived;
    },
  },
  async created() {
    this.fillData();
  },
};
</script>

<style lang="scss"></style>
